export interface ISynergyConfig {
  corporateId: number;
  outletId: number;
}
